// TODO(sierra-widget-removal): entire module unused after Shippy/Sierra split — delete in follow-up PR.
import { initSierraChat } from './sierra-chat/sierra-chat-service';
import SuncoService from './sunco-chat/sunco-chat-service';
import { AnalyticsService } from '../../services/analytics-service';
import { LogService } from '../../services/log-service';

export const initSupportChat = ({
  name,
  email,
  sellerId,
  homeCountry,
  subscriptionPlan,
  activationDate,
  locale,
  userHasAdmin,
  billingCycleDate,
  featureFlags,
  ssEnvironment,
  organizationIdSeller,
  ssPlanVolume,
  businessName,
  userId,
  chatInitOrigin,
  features,
}) => {
  const enableSuncoChatAuth = featureFlags.enableSuncoAuthorization;
  const useSierraChat = featureFlags.enableSierraChat;
  if (useSierraChat) {
    initSierraChat(
      {
        name,
        email,
        sellerId,
        homeCountry,
        subscriptionPlan,
        activationDate,
        locale,
        userHasAdmin,
        billingCycleDate,
        ssEnvironment,
        organizationIdSeller,
        ssPlanVolume,
        businessName,
        userId,
        features,
      },
      chatInitOrigin,
    )
      .then(() => {
        // Track successful Sierra chat launch
        AnalyticsService.trackEvent('Chat Launched', {
          provider: 'sierra',
          timestamp: new Date().toISOString(),
        });
      })
      .catch((error) => {
        LogService.logError(new Error('Sierra Chat failed, falling back to Sunco', { cause: error }));

        // todo remove when we get rid of sunco
        // Fallback to Sunco on Sierra failure
        SuncoService.initSuncoChat(
          name,
          email,
          sellerId,
          homeCountry,
          subscriptionPlan,
          activationDate,
          locale,
          userHasAdmin,
          billingCycleDate,
          enableSuncoChatAuth,
        );

        // Track fallback usage
        AnalyticsService.trackEvent('Chat Launched', {
          provider: 'sunco',
          fallbackReason: 'sierra_failed',
          timestamp: new Date().toISOString(),
        });
      });
    return;
  }
  SuncoService.initSuncoChat({
    name,
    email,
    sellerId,
    homeCountry,
    subscriptionPlan,
    activationDate,
    locale,
    userHasAdmin,
    billingCycleDate,
    enableSuncoChatAuth,
  });
};
